let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3kje")).then(() => parcelRequire('9gjfb'));